import { __assign } from "tslib";
import { renderAndMountComponent } from '@wix/answers-lib';
import * as React from 'react';
import { DeprecatedLinkButton } from './link-button';
import { getLegacyBaseDriverFromWrapper } from '../../../common/base-driver';
export var createLinkButtonLegacyDriver = function (wrapper) {
    var classNames = '.deprecated-link-button';
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, classNames, DeprecatedLinkButton.name);
    return {
        click: function () { return baseDriver.click(); },
        getText: function () { return baseDriver.elem.innerHTML; },
        isDisabled: function () { return baseDriver.elem.hasAttribute('disabled'); },
        loaderVisible: function () { return false; }
    };
};
export var createLinkButton = function (props) {
    var element = renderAndMountComponent(React.createElement(DeprecatedLinkButton, __assign({}, props), props.children));
    return createLinkButtonLegacyDriver(element);
};
//# sourceMappingURL=link-button.legacy-driver.js.map